import * as DropdownPrimitive from "@radix-ui/react-dropdown-menu";
import { Check, ChevronDown, Languages } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LANGUAGES, setLanguage, type Language } from "@/i18n";
import { cn } from "@/lib/utils";

export function LanguageMenu({ onChange, align = "end", side = "bottom" }: { onChange?: (lang: Language) => void; align?: "start" | "end"; side?: "top" | "bottom" }) {
  const { i18n, t } = useTranslation();
  const current = LANGUAGES.find((l) => i18n.language.startsWith(l.code)) ?? LANGUAGES[0];
  const select = (code: string) => {
    const lang = code as Language;
    if (lang === current.code) return;
    setLanguage(lang);
    onChange?.(lang);
  };
  return (
    <DropdownPrimitive.Root>
      <DropdownPrimitive.Trigger
        className="flex items-center gap-1 rounded-md p-1.5 text-xs text-fg-muted outline-none hover:bg-muted hover:text-fg data-[state=open]:bg-muted"
        aria-label={`${t("nav.language")}: ${current.label}`}
        title={t("nav.language")}
      >
        <Languages className="h-4 w-4" />
        {current.code.toUpperCase()}
        <ChevronDown className="h-3 w-3" />
      </DropdownPrimitive.Trigger>
      <DropdownPrimitive.Portal>
        <DropdownPrimitive.Content align={align} side={side} sideOffset={6} className="z-50 min-w-36 rounded-md border bg-panel p-1 shadow-lg">
          <DropdownPrimitive.RadioGroup value={current.code} onValueChange={select}>
            {LANGUAGES.map((l) => (
              <DropdownPrimitive.RadioItem
                key={l.code}
                value={l.code}
                lang={l.code}
                className={cn("flex cursor-pointer select-none items-center gap-2 rounded px-2.5 py-1.5 text-sm outline-none data-[highlighted]:bg-muted", l.code === current.code && "font-medium")}
              >
                <span className="w-4">
                  <DropdownPrimitive.ItemIndicator>
                    <Check className="h-4 w-4" />
                  </DropdownPrimitive.ItemIndicator>
                </span>
                {l.label}
              </DropdownPrimitive.RadioItem>
            ))}
          </DropdownPrimitive.RadioGroup>
        </DropdownPrimitive.Content>
      </DropdownPrimitive.Portal>
    </DropdownPrimitive.Root>
  );
}
